import { Box, Flex, Skeleton, SkeletonCircle } from "@chakra-ui/react";
import React from "react";

function ShowListSkeleton() {
  return (
    <Box px="1rem" py="1rem" background="blackAlpha.50">
      <Flex justifyContent="space-between">
        <Box></Box>
        <Flex gap="1rem">
          <SkeletonCircle size="3.5rem" />
          <SkeletonCircle size="3.5rem" />
          <SkeletonCircle size="3.5rem" />
          <SkeletonCircle size="3.5rem" />
        </Flex>
      </Flex>
      <Flex
        mt="1rem"
        borderRadius="lg"
        overflow="hidden"
        gap="2rem"
        background="blackAlpha.200"
      >
        <Skeleton height="5rem" width="8rem" />
        <Flex gap="1rem" alignItems="center">
          <Skeleton height="2.5rem" width="5rem" />
          <Skeleton height="2.5rem" width="5rem" />
          <Skeleton height="2.5rem" width="5rem" />
          <Skeleton height="2.5rem" width="5rem" />
        </Flex>
      </Flex>
    </Box>
  );
}

export default ShowListSkeleton;
